import { render } from "./AmLich.vue?vue&type=template&id=565f57b0"
import script from "./AmLich.vue?vue&type=script&lang=js"
export * from "./AmLich.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wamp64\\www\\comd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__